import { SectionCard, StatTile } from "../Domain";
import { EXTRACTION_SUMMARY_COPY } from "./utilities";

export interface ExtractionSummaryProps {
    total: number;
    fullyDecomposed: number;
    notDecomposed: number;
    clausesSeen: number;
    clausesWithoutModal: number;
}

export function ExtractionSummarySection({
    total,
    fullyDecomposed,
    notDecomposed,
    clausesSeen,
    clausesWithoutModal,
}: ExtractionSummaryProps) {
    return (
        <SectionCard
            headerLabel={EXTRACTION_SUMMARY_COPY.header}
            rightLabel={EXTRACTION_SUMMARY_COPY.right}
        >
            <div className="grid grid-cols-2 gap-3 p-4 md:grid-cols-3 lg:grid-cols-5">
                <StatTile value={total} label="Normative requirements" tone="cyan" />
                <StatTile value={fullyDecomposed} label="Fully decomposed" tone="emerald" />
                <StatTile value={notDecomposed} label="Not decomposed (cap)" tone="amber" />
                <StatTile value={clausesSeen} label="Clauses seen" tone="indigo" />
                <StatTile
                    value={clausesWithoutModal}
                    label="Clauses without a modal"
                    tone="amber"
                />
            </div>
        </SectionCard>
    );
}
